import { render } from "./PortalHeader.vue?vue&type=template&id=ca29a4e6&scoped=true"
import script from "./PortalHeader.vue?vue&type=script&lang=js"
export * from "./PortalHeader.vue?vue&type=script&lang=js"

import "./PortalHeader.vue?vue&type=style&index=0&id=ca29a4e6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca29a4e6"]])

export default __exports__